import { Moment } from 'moment'
import { service } from '.'

export interface DailyReportItem {
  id: number,
  dealerId: number, dealerName: string,
  storeId: number, storeName: string,
  ymd: string, caseCount: number
}

class DailyReportStore {
  private _items: DailyReportItem[] = []

  get items() { return this._items }

  loadAll = async (date: Moment) => {
    const res = await service.getDailyReports(date.format('YYYYMMDD'))
    if (res.status === 200) {
      this._items = await res.json()
      return Promise.resolve()
    }
    else if(res.status === 401) { }
    else {
      const body = await res.json()
      const msg = body?.detail ?? body?.message
      throw new Error(`${msg}, ${res.status}`)
    }
  }
}

export const dailyReportStore = new DailyReportStore()